var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { ref: "topEl" }),
    _vm._v(" "),
    _c("div", { staticClass: "row no-gutters mb-3" }, [
      _c("div", { staticClass: "col-md-6 display-1 my-auto" }, [
        _vm._v(_vm._s(_vm.pageHeader))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mt-2 mb-4 add-carrier-block" }, [
      _c(
        "div",
        [
          _c(
            "b-tabs",
            {
              model: {
                value: _vm.tabIndex,
                callback: function($$v) {
                  _vm.tabIndex = $$v
                },
                expression: "tabIndex"
              }
            },
            [
              _c(
                "b-tab",
                {
                  staticClass: "mt-3",
                  attrs: { title: "Carrier Integration" }
                },
                [
                  _c("form", { attrs: { action: "self" } }, [
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c("div", { staticClass: "col-12 col-md-5 mb-3" }, [
                        _c(
                          "fieldset",
                          { staticClass: "border border-primary p-2 rounded" },
                          [
                            _c(
                              "legend",
                              {
                                staticClass:
                                  "w-auto px-2 font-weight-bold smaller-font-content text-primary"
                              },
                              [_vm._v("Carrier Integration Set Up")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "px-3 my-2",
                                attrs: { id: "user_section" }
                              },
                              [
                                _c("input-text", {
                                  attrs: { fieldData: _vm.carrierName }
                                }),
                                _vm._v(" "),
                                _c("input-text", {
                                  attrs: { fieldData: _vm.carrierTag }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-subtext pr-2 cartag mb-3"
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "form-text smaller-font-content",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.carrierTag.sub_text
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input-product-type", {
                                  attrs: { insuranceType: _vm.insuranceType }
                                }),
                                _c("input-select", {
                                  attrs: { fieldData: _vm.integrationType }
                                }),
                                _vm._v(" "),
                                _vm.showRateCallBox
                                  ? _c("input-select", {
                                      attrs: { fieldData: _vm.ratecallType }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "def-ext" },
                                  [
                                    _vm.showDefautlIDBox
                                      ? _c("input-text", {
                                          attrs: {
                                            fieldData: _vm.defaultCarrierId
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("input-select", {
                                  attrs: { fieldData: _vm.carrierState }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "radio-field" },
                                  [
                                    _c("input-radio-button", {
                                      attrs: { fieldData: _vm.carrierStatus }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-right px-3 pb-3" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-secondary",
                                  attrs: {
                                    type: "button",
                                    id: "add-user-cancel",
                                    tabindex: "1"
                                  },
                                  on: { click: _vm.redirectToList }
                                },
                                [_vm._v("Cancel")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-success ml-3",
                                  attrs: { type: "button", tabindex: "1" },
                                  on: { click: _vm.saveCarrier }
                                },
                                [_vm._v("Save Carrier")]
                              )
                            ])
                          ]
                        )
                      ])
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("b-tab", {
                attrs: { title: "Agency Integrations", disabled: true }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f8549c0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8549c0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/carriers/AddCarrier.vue
// module id = null
// module chunks = 